import createUser from './actions/createUser';
import currentUser from './actions/currentUser';
import getUser from './actions/getUser';
import updateUser from './actions/updateUser';
import usersList from './actions/usersList';
import getUsers from './getters/getUsers';
import profile from './getters/profile';
import setProfile from './mutations/setProfile';
import uploadUsers from './mutations/uploadUsers';

const actions = {
    currentUser,
    createUser,
    updateUser,
    usersList,
    getUser
};

const mutations = {
    setProfile,
    uploadUsers
};

const getters = {
    profile,
    getUsers
};

export default { actions, mutations, getters };
